import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Role } from 'app/core/user/user.types';
import { map, take } from 'rxjs';
import { AuthService } from '../auth.service';

export const MechanicRedirectGuard: CanActivateFn = () => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.user$.pipe(
        take(1),
        map((user) => {
            if (user?.role === Role.Mechanic) {
                return router.parseUrl('/saisies-atelier');
            }
            return true;
        }),
    );
};
